import React, { Component } from 'react';

import Table from 'react-bootstrap/Table';
import { FormattedMessage } from 'react-intl';
import Spinner from 'react-bootstrap/Spinner';
import {Link} from "react-router-dom";

class DynamicTable extends Component {
  constructor(props){
    super(props);
    this.state={
      nextButtonStatus: false,
      previousButtonStatus: true,
      ascending: true,
      showSelect: typeof props.showSelect !== 'undefined' ? props.showSelect : false,
    };

    this.changeOrder = this.changeOrder.bind(this);
    this.changePage = this.changePage.bind(this);
  }

  changeOrder = () => {
    this.setState({
      ascending: !this.state.ascending
    }, function() {
      this.dataGeter();
    })
  };

  changePage = (direction) => {
    this.props.changePage(direction)
  };

  saveDiagnosticSubjectLevelId(id){
    sessionStorage.setItem("diagnosticSubjectLevelId", id);
  }

  selectAdditionalMaterial(id){
    this.props.updateParent(id);
  }

  render() {
    return (
      <div>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th><FormattedMessage id="tb-subject"/></th>
              <th><FormattedMessage id="tb-level"/></th>
              <th><FormattedMessage id="d-column-dianostic-status"/></th>
              <th><FormattedMessage id="tb-generate"/></th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.data.length === 0 ? <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}><Spinner animation="grow"/></div> :
              this.props.data.map((item, index) => {
              return (
                <tr key={index}>
                  <td key={(index + "SUBJECT").toString}>{item.SubjectName}</td>
                  <td key={(index) + "LEVEL"}>{item.LevelName}</td>
                  <td key={(index) + "STATUS"}>{item.DiagnosticTestStatus}</td>
                  <td key={(index) + "GENERATE"}>
                  {
                    <Link
                        onClick={() => this.saveDiagnosticSubjectLevelId(item.Id)}
                        to={{pathname: item.linkItems[0].link, id: item.Id}}>
                        {item.linkItems[0].linkText ? item.linkItems[0].linkText : <FormattedMessage id="qp-viewOrEdit"/>}
                    </Link>
                  }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
export default DynamicTable;